<ui-confirmation-dialog
    #mobileConfirmationDialog
    header="mobile-warning-dialog.title"
    primaryButtonLabel="continue"
    secondaryButtonLabel="document.goBack"
>
    {{ 'mobile-warning-dialog.description' | translate }}
</ui-confirmation-dialog>
